import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faWrench, faEdit, faTrashCan, faCheck, faTriangleExclamation, faChevronLeft } from '@fortawesome/free-solid-svg-icons'

library.add(faWrench, faEdit, faTrashCan, faCheck, faTriangleExclamation, faChevronLeft)
dom.watch()
